import React, { useMemo } from 'react'

//@ts-ignore
import styles from './style.module.css'
import { handleDelete } from '../../../../utils/actions'

import { cx } from '@emotion/css';
import { useFocused, useSelected } from 'slate-react';
import { handleClick } from '../utils/referenceButton'
import Icon from '../../../../../../../Icon2';
import Tooltip from '../../../../../../../Tooltip/Tooltip';
import { ReferenceComponent } from './components';

const EmbedBtn = ({ content, onClick, children, title, testId = "scrte-embed-btn" }) => {
  return (
    <Tooltip position='bottom' content={content}>

      <button id={title} onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick(e);
      }}
        data-testid={testId}
      >
        {children}
      </button>
    </Tooltip>
  )
}

//  to be moved in components
export const EmbedBtnGrp = ({ isError, isDisabled, handleEdit, editor, attributes, handleDelete, handleUnlink, handleCaption, type, error }) => (
  <>
    {!isError && !isDisabled &&
      <EmbedBtn title='edit' content={type === 'asset' ? 'View Asset' : 'Edit Entry'} onClick={handleEdit} testId={"embed-asset-view"}>
        <Icon version='v2' icon={type === 'asset' ? 'Eye' : 'Edit'} />
      </EmbedBtn>
    }
    {type !== 'asset' && !isDisabled && handleClick &&
      <EmbedBtn title='replace' content='Replace' onClick={(e) => handleClick(e, editor, { title: 'Replace Entry', type, prefilled: true, attributes })} testId={"embed-entry-replace"} >
        <Icon version='v2' icon="Replace" />
      </EmbedBtn>}
    {handleUnlink && !isDisabled &&
      <EmbedBtn title='unlink' content='Unlink' onClick={handleUnlink} testId={"embed-asset-unlink"}>
        <UnlinkIcon />
      </EmbedBtn>}
    {type === 'asset' && !isDisabled && handleCaption &&
      <EmbedBtn title='caption' content='Edit' onClick={handleCaption} testId={"embed-asset-edit"}>
        <Icon version='v2' icon='ImageSettings' />
      </EmbedBtn>
    }
    {handleDelete &&
      <EmbedBtn title='delete' content='Delete' onClick={handleDelete} testId={"embed-asset-delete"}>
        <Icon version='v2' icon='Delete'></Icon>
      </EmbedBtn>}

    {type !== 'asset' && type !== 'link' && type !== 'assetLink' ? (
      <InfoIcon error={error} isDisabled={isDisabled} />
    ) : null}
  </>
)

export const InfoIcon = ({ error, isDisabled }) => {
  if (error) {
    return (
      <Tooltip className={'embed-error'} content={error} position='bottom' variantType='dark' >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.7762 4.28593L2.97219 18.2449C2.84787 18.4679 2.78231 18.7208 2.78209 18.9783C2.78187 19.2358 2.84699 19.4888 2.97094 19.7121C3.09488 19.9353 3.27329 20.1209 3.4883 20.2502C3.70331 20.3795 3.94736 20.4481 4.196 20.449H19.804C20.0526 20.4481 20.2967 20.3795 20.5117 20.2502C20.7267 20.1209 20.9051 19.9353 21.0291 19.7121C21.153 19.4888 21.2181 19.2358 21.2179 18.9783C21.2177 18.7208 21.1521 18.4679 21.0278 18.2449L13.2238 4.28593C13.1004 4.06265 12.9223 3.87709 12.7073 3.74803C12.4924 3.61898 12.2484 3.55101 12 3.55101C11.7516 3.55101 11.5076 3.61898 11.2927 3.74803C11.0777 3.87709 10.8996 4.06265 10.7762 4.28593Z" fill="#FFAE0A" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0257 3.27137C11.3217 3.09362 11.6578 3 12 3C12.3422 3 12.6783 3.09362 12.9743 3.27137C13.2699 3.44888 13.515 3.70401 13.6849 4.01099L13.6856 4.01224L21.4883 17.9689C21.6592 18.2755 21.7497 18.6238 21.75 18.9778C21.7503 19.3319 21.6608 19.6798 21.4903 19.9867C21.3199 20.2937 21.0746 20.5488 20.779 20.7267C20.4833 20.9045 20.1478 20.9988 19.8059 21L19.804 21H4.196L4.19413 21C3.85224 20.9988 3.51667 20.9045 3.22104 20.7267C2.9254 20.5488 2.68009 20.2937 2.50967 19.9867C2.33924 19.6798 2.2497 19.3319 2.25 18.9778C2.2503 18.6238 2.34044 18.276 2.51139 17.9694L10.3144 4.01224L10.3151 4.01099C10.485 3.70401 10.7301 3.44888 11.0257 3.27137ZM10.7762 4.28593L11.2367 4.56201L3.433 18.5204V18.5204C3.35537 18.6598 3.31432 18.818 3.31418 18.9788C3.31404 19.1397 3.35475 19.2979 3.43221 19.4374C3.50968 19.5769 3.62118 19.6929 3.75556 19.7737C3.88974 19.8544 4.04202 19.8973 4.19718 19.898H19.8028C19.958 19.8973 20.1103 19.8544 20.2444 19.7737C20.3788 19.6929 20.4903 19.5769 20.5678 19.4374C20.6453 19.2979 20.686 19.1397 20.6858 18.9788C20.6857 18.8179 20.6447 18.6598 20.567 18.5204L12.762 4.55962C12.6852 4.4206 12.5742 4.30505 12.4404 4.2247C12.3066 4.14435 12.1547 4.10203 12 4.10203C11.8453 4.10203 11.6934 4.14435 11.5596 4.2247C11.4258 4.30506 11.3148 4.42059 11.238 4.55962L10.7762 4.28593Z" fill="#475161" />
          <path fill-rule="evenodd" clip-rule="evenodd" d="M12.005 9.61216C12.2989 9.61216 12.5371 9.85886 12.5371 10.1632V13.8366C12.5371 14.1409 12.2989 14.3876 12.005 14.3876C11.7111 14.3876 11.4729 14.1409 11.4729 13.8366V10.1632C11.4729 9.85886 11.7111 9.61216 12.005 9.61216Z" fill="#475161" />
          <path d="M12.005 18.061C12.4948 18.061 12.8918 17.6499 12.8918 17.1427C12.8918 16.6355 12.4948 16.2243 12.005 16.2243C11.5152 16.2243 11.1182 16.6355 11.1182 17.1427C11.1182 17.6499 11.5152 18.061 12.005 18.061Z" fill="#475161" />
        </svg>
      </Tooltip>
    );
  }

  if (isDisabled) {
    return (
      <Tooltip appendTo={document.body} className={'embed-error'} content='This feature is not available in your plan.' position='bottom'>
        <Icon icon="Docs" />
      </Tooltip>
    )
  }

  return null;
}


// to be moved in components


export const InlineReference = ({ entry, editor, element, ...props }) => {
  const { history, apiKey } = editor?.requestProps || {};
  const currentBranch = editor?.requestProps?.branch
  const contentTypeUid = element?.attrs?.['content-type-uid'],
    entryUid = element?.attrs?.['entry-uid'],
    locale = element?.attrs?.['locale'];

  const handleEdit = (e: Event) => {
    if (editor?.referenceActions?.editInlineReference) {
      editor.referenceActions.editInlineReference({ contentTypeUid, entryUid, locale })
      return;
    }

    const pathname = `/stack/${apiKey}/content-type/${contentTypeUid}/${locale}/entry/${entryUid}/edit`
    const search = currentBranch ? `branch=${currentBranch}` : ''
    const state = editor.isDraft ? editor.getReferredObj({ ctUid: contentTypeUid, blockUid: element.uid, pathname, search }) : {}

    const newHistoryData: Record<string, any> = {
      pathname,
      search,
    }

    if (editor.isDraft) {
      newHistoryData.state = state
    }

    history.push(newHistoryData)
  }
  return (
    <ReferenceComponent type='inline' entry={entry} editor={editor} content_type_uid={contentTypeUid} handleEdit={handleEdit} handleDelete={() => handleDelete(editor, element)} attributes={{ ...props.attributes, ...props.attrs, element }} children={props.children} />
  )
}


function UnlinkIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.5756 8.41446C15.7954 8.63397 15.7957 8.99012 15.5762 9.20995L13.9871 10.8014C13.7676 11.0212 13.4114 11.0215 13.1916 10.8019C12.9718 10.5824 12.9715 10.2263 13.191 10.0065L14.7801 8.41505C14.9996 8.19521 15.3557 8.19495 15.5756 8.41446Z" fill="#475161" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M10.8085 13.1887C11.0284 13.4082 11.0286 13.7643 10.8091 13.9842L9.22006 15.5756C9.00055 15.7954 8.6444 15.7957 8.42457 15.5762C8.20474 15.3567 8.20447 15.0005 8.42398 14.7807L10.013 13.1893C10.2326 12.9694 10.5887 12.9692 10.8085 13.1887Z" fill="#475161" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.62587 10.0085C7.84554 10.2282 7.84554 10.5843 7.62587 10.804L4.97275 13.4571C4.2341 14.1958 3.81914 15.1976 3.81914 16.2422C3.81914 17.2868 4.2341 18.2886 4.97275 19.0273C5.71139 19.7659 6.71321 20.1809 7.75781 20.1809C8.27505 20.1809 8.78722 20.079 9.26508 19.8811C9.74294 19.6831 10.1771 19.393 10.5429 19.0273L13.196 16.3741C13.4157 16.1545 13.7718 16.1545 13.9915 16.3741C14.2112 16.5938 14.2112 16.95 13.9915 17.1696L11.3384 19.8227C10.8682 20.293 10.31 20.6659 9.6956 20.9204C9.08124 21.1749 8.42278 21.3059 7.75781 21.3059C6.41484 21.3059 5.12688 20.7724 4.17725 19.8227C3.22763 18.8731 2.69414 17.5852 2.69414 16.2422C2.69414 14.8992 3.22763 13.6113 4.17725 12.6616L6.83038 10.0085C7.05005 9.78883 7.4062 9.78883 7.62587 10.0085Z" fill="#475161" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6616 4.17725C13.6113 3.22763 14.8992 2.69414 16.2422 2.69414C17.5852 2.69414 18.8731 3.22763 19.8227 4.17725C20.7724 5.12688 21.3059 6.41484 21.3059 7.75781C21.3059 9.10078 20.7724 10.3887 19.8227 11.3384L17.1696 13.9915C16.95 14.2112 16.5938 14.2112 16.3741 13.9915C16.1545 13.7718 16.1545 13.4157 16.3741 13.196L19.0273 10.5429C19.7659 9.80423 20.1809 8.80241 20.1809 7.75781C20.1809 6.71321 19.7659 5.71139 19.0273 4.97275C18.2886 4.2341 17.2868 3.81914 16.2422 3.81914C15.1976 3.81914 14.1958 4.2341 13.4571 4.97275L10.804 7.62587C10.5843 7.84554 10.2282 7.84554 10.0085 7.62587C9.78883 7.4062 9.78883 7.05005 10.0085 6.83038L12.6616 4.17725Z" fill="#475161" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.25 1.6875C8.56066 1.6875 8.8125 1.93934 8.8125 2.25V5.25C8.8125 5.56066 8.56066 5.8125 8.25 5.8125C7.93934 5.8125 7.6875 5.56066 7.6875 5.25V2.25C7.6875 1.93934 7.93934 1.6875 8.25 1.6875Z" fill="#475161" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M15.75 18.1875C16.0607 18.1875 16.3125 18.4393 16.3125 18.75V21.75C16.3125 22.0607 16.0607 22.3125 15.75 22.3125C15.4393 22.3125 15.1875 22.0607 15.1875 21.75V18.75C15.1875 18.4393 15.4393 18.1875 15.75 18.1875Z" fill="#475161" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M1.6875 8.25C1.6875 7.93934 1.93934 7.6875 2.25 7.6875H5.25C5.56066 7.6875 5.8125 7.93934 5.8125 8.25C5.8125 8.56066 5.56066 8.8125 5.25 8.8125H2.25C1.93934 8.8125 1.6875 8.56066 1.6875 8.25Z" fill="#475161" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M18.1875 15.75C18.1875 15.4393 18.4393 15.1875 18.75 15.1875H21.75C22.0607 15.1875 22.3125 15.4393 22.3125 15.75C22.3125 16.0607 22.0607 16.3125 21.75 16.3125H18.75C18.4393 16.3125 18.1875 16.0607 18.1875 15.75Z" fill="#475161" />
    </svg>
  )
}

export * from './withInlineReference'
export * from './deserializer';
export * from './components'
